import React from "react";
import { Link } from "react-router-dom";

// App imports
// import styles from "../../styles/index.module.css";
import NavItem from "./NavItem";
import { Button } from "@mui/material";
import { ThemeToggle } from "../toggle/ThemeToggle";
import { selectTheme } from "../../../store/reducers/theme";
import { useSelector } from "react-redux";
import ThemeToggleSwitch from "../toggle/ThemeToggleSwitch";
import PriseenLogo from "../logos/PriseenLogo";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { motion, AnimatePresence } from "framer-motion";
import useBreakpoint from "../../../hooks/useBreakpoint";

const navItems = [
  { item: "Home", href: "#hero-section" },
  { item: "About Us", href: "#technology" },
  { item: "Contact", href: "#pricing" },
];

const logoVariants = {
  initial: { y: 100, opacity: 0 }, // Offscreen below with zero opacity
  animate: { y: 0, opacity: 1 }, // Slide in to natural position
  exit: { y: 100, opacity: 0 }, // Slide back down on unmount
};

const stickyClasses = "shadow-lg bg-default/[0.2]";
const normalClasses = "";
const Navbar = ({ isSticky }) => {
  const { resolvedMode } = useSelector(selectTheme);
  const breakpoint = useBreakpoint();

  return (
    <div
      className={`${
        !isSticky ? "hidden" : ""
      } header-container fixed top-0 left-0 w-full z-[23]`}
    >
      <header
        className={`w-full backdrop-blur-[30px] flex justify-center
          ${isSticky ? stickyClasses : normalClasses}`}
      >
        <nav className="px-[16px] md:px-0 lg:px-0 py-[20px] flex items-center justify-between w-full section-content-container">
          {/* Logo on the left */}
          <div className="flex-shrink-0 animate-slideInBottom">
            <AnimatePresence>
              {isSticky && (
                <motion.a
                  href="/"
                  variants={logoVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                  <PriseenLogo />
                </motion.a>
              )}
            </AnimatePresence>
          </div>

          {/* Navigation items on the right */}
          <div className="flex gap-4 flex items-center">
            {/* {navItems.map((item) => (
              <NavItem
                isSticky={isSticky}
                item={item.item}
                href={item.href}
                key={item.href}
              />
            ))} */}
            <div className="flex-shrink-0 animate-slideInBottom">
              <AnimatePresence>
                {isSticky && (
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/priseen"
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      size={
                        ["xs", "sm"].includes(breakpoint) ? "small" : "large"
                      }
                    >
                      Follow on
                      <LinkedInIcon className="text-[20px] transition-all duration-500 transform ml-1" />
                    </Button>
                  </a>
                )}
              </AnimatePresence>
            </div>

            {/* <a href="#contact-section" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                color="secondary"
                className="hidden md:flex"
              >
                Book a demo
              </Button>
            </a> */}

            {/* <ThemeToggleSwitch /> */}
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
